import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api, { getCsrfCookie } from '../../services/api';
import ROUTES from '../../route';
import { useUser } from '../State/UserContext';

const Register = () => {
    const { setUser } = useUser();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ name: '', email: '', password: '', password_confirmation: '' });
    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (localStorage.getItem('api_token')) {
            navigate(ROUTES.HOME);
        }
    }, [navigate]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setErrors({ ...errors, [e.target.name]: undefined });
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        setErrors({});
        setMessage('');
        try {
            await getCsrfCookie();
            const response = await api.post('/register', formData);
            if (response.data.success) {
                setUser(response.data.user);
                localStorage.setItem('api_token', response.data.token);
                navigate(ROUTES.HOME);
            }
        } catch (error) {
            if (error.response?.data?.errors) {
                setErrors(error.response.data.errors);
            } else {
                setMessage(error.response?.data?.message ?? 'Registration failed. Please try again.');
            }
        }
    };

    const inputClass = "w-full px-4 py-3 bg-warm-50 border border-warm-200 rounded-lg text-warm-800 placeholder-warm-300 focus:outline-none focus:ring-2 focus:ring-warm-400 focus:border-transparent transition";
    const errorClass = "mt-1 text-xs text-red-500";

    return (
        <div className="min-h-screen bg-warm-50 flex items-center justify-center px-4 py-12">
            <div className="w-full max-w-md">
                <div className="text-center mb-8">
                    <Link to={ROUTES.DEFAULT} className="inline-flex items-center gap-2 font-serif text-2xl font-bold text-warm-800 hover:text-warm-600 transition-colors mb-4">
                        <span className="text-3xl">📚</span>
                        My Books Library
                    </Link>
                    <h1 className="font-serif text-3xl font-bold text-warm-800 mb-2">Create your account</h1>
                    <p className="text-warm-400 text-sm">Start building your personal library today</p>
                </div>

                <div className="bg-white rounded-2xl shadow-lg border border-warm-200 p-8">
                    <form onSubmit={handleRegister} className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-warm-700 mb-1.5">Name</label>
                            <input
                                type="text"
                                name="name"
                                placeholder="Your name"
                                value={formData.name}
                                onChange={handleChange}
                                className={inputClass}
                                required
                            />
                            {errors.name && <p className={errorClass}>{errors.name[0]}</p>}
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-warm-700 mb-1.5">Email</label>
                            <input
                                type="email"
                                name="email"
                                placeholder="you@example.com"
                                value={formData.email}
                                onChange={handleChange}
                                className={inputClass}
                                required
                            />
                            {errors.email && <p className={errorClass}>{errors.email[0]}</p>}
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-warm-700 mb-1.5">Password</label>
                            <input
                                type="password"
                                name="password"
                                placeholder="••••••••"
                                value={formData.password}
                                onChange={handleChange}
                                className={inputClass}
                                required
                            />
                            {errors.password && <p className={errorClass}>{errors.password[0]}</p>}
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-warm-700 mb-1.5">Confirm Password</label>
                            <input
                                type="password"
                                name="password_confirmation"
                                placeholder="••••••••"
                                value={formData.password_confirmation}
                                onChange={handleChange}
                                className={inputClass}
                                required
                            />
                        </div>
                        <button
                            type="submit"
                            className="w-full bg-warm-600 hover:bg-warm-700 text-white font-semibold py-3 rounded-lg transition-colors duration-200 mt-2"
                        >
                            Create Account
                        </button>
                    </form>

                    {message && (
                        <p className="mt-4 text-center text-sm text-red-500">{message}</p>
                    )}

                    <p className="mt-6 text-center text-sm text-warm-400">
                        Already have an account?{' '}
                        <Link to={ROUTES.LOGIN} className="text-warm-600 hover:text-warm-800 font-medium transition-colors">
                            Sign in
                        </Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Register;
